import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';

function BusinessActivities({
  data,
}) {

  return (
    <div className="m-3">
      {data.length > 0
        ? data.map(businessActivity => {
            return (
              <div key={businessActivity.id}>
                <table className="transaction-table table table-striped table-borderless table-sm">
                  <tbody>
                    <tr>
                      <td className="text-dark font-weight-bold" width="250">
                        Activity Type
                      </td>
                      <td className="text-dark font-weight-bold" width="1">
                        :
                      </td>
                      <td colSpan={4}>
                        <b>{get(businessActivity, 'attributes.activity_type') || '-'}</b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark font-weight-bold" width="250">
                        Line of Business
                      </td>
                      <td className="text-dark font-weight-bold" width="1">
                        :
                      </td>
                      <td colSpan={4}>
                        <b>{get(businessActivity, 'attributes.business_line') || '-'}</b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark font-weight-bold" width="250">
                        Products/Services
                      </td>
                      <td className="text-dark font-weight-bold" width="1">
                        :
                      </td>
                      <td colSpan={4}>
                        <b>{get(businessActivity, 'attributes.products_services') || '-'}</b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark font-weight-bold" width="250">
                        No. of Units
                      </td>
                      <td className="text-dark font-weight-bold" width="1">
                        :
                      </td>
                      <td colSpan={4}>
                        <b>{get(businessActivity, 'attributes.no_of_units') || '-'}</b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark font-weight-bold" width="250">
                        Capitalization
                      </td>
                      <td className="text-dark font-weight-bold" width="1">
                        :
                      </td>
                      <td colSpan={4}>
                        <b>{get(businessActivity, 'attributes.total_capitalization_human') || '-'}</b>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark font-weight-bold" width="250">
                        Gross Sales
                      </td>
                      <td className="text-dark font-weight-bold" width="1">
                        :
                      </td>
                      <td colSpan={4}>
                        <b>{get(businessActivity, 'attributes.gross_sales_human') || '-'}</b>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <hr />
              </div>
            );
          })
        : null}
    </div>
  );
}

BusinessActivities.defaultProps = {
  data: {},
};

BusinessActivities.propTypes = {
  data: PropTypes.instanceOf(Object),
};

export default BusinessActivities;
